<script>
import { Dropdown, Menu, MenuItem } from 'ant-design-vue';
import BaseIcon from '@/rex-components/BaseIcon.vue';

export default {
  emits: ['itemClick'],
  components: { Dropdown, MenuComp: Menu, MenuItem, BaseIcon },
  props: {
    items: {
      type: Array,
      required: true,
    },
    placement: {
      type: String,
      default: 'bottomRight',
    },
    arrow: {
      type: Boolean,
      default: false,
    },
    overlayStyle: {
      type: Object,
      default: () => ({}),
    },
    trigger: {
      type: String,
      default: 'click',
    },
  },
};
</script>

<template>
  <div>
    <Dropdown
      :placement="placement"
      :arrow="arrow"
      :overlayStyle="overlayStyle"
      :trigger="trigger"
    >
      <div>
        <slot></slot>
      </div>
      <template #overlay>
        <MenuComp class="rex-drop-down-menu">
          <MenuItem
            v-for="item in items"
            :key="item.key"
            @click="() => $emit('itemClick', item)"
          >
            <BaseIcon
              class="rex-drop-down-icon"
              v-if="item.icon"
              :name="item.icon"
              width="1.125rem"
              height="0.875rem"
            />
            {{ item.label }}
          </MenuItem>
        </MenuComp>
      </template>
    </Dropdown>
  </div>
</template>

<style lang="scss" scoped>
.rex-drop-down-menu {
  text-align: left;
}
.rex-drop-down-icon {
  stroke: $color-white;
  @include svg-fill-pointer($bg-secondary);
  margin-right: 0.5rem;
}
</style>
